import axios from 'axios'
import router from '@/router/index'

import CookieHelper from '@/helpers/cookie/index'
import isLogged from '@/helpers/api/isLogged'
import $apiConfig from '@/helpers/config/index'
import store from '@/store/index'
import {
    Notification,
} from 'element-ui'
import {
    signalingManager,
} from '@/utils/audioHandler'

window.cookieBridge = new CookieHelper()

function hasRefreshToken() {
    const token = window.cookieBridge.getCookie('refresh_token')
    return token !== undefined && token !== 'undefined'
}

function logout() {
    window.cookieBridge.deleteCookie('access_token')
    window.cookieBridge.deleteCookie('refresh_token')
    window.cookieBridge.deleteCookie('expires_in')
    Notification.closeAll()
    signalingManager.stop()

    if (router.currentRoute.name !== 'Login') {
        router.push('/auth/login')
    }

    setTimeout(() => {
        store.commit('setIsLogged', false)
        store.commit('setIsLoading', false)
    }, 300)
}

function canSendRequest(url) {
    const allowedUrl = ['/signin']

    return allowedUrl.includes(url)
}

let isUpdating = false

async function updateToken() {
    if (isUpdating) return

    isUpdating = true
    const token = window.cookieBridge.getCookie('refresh_token')
    const response = await axios.post(`${$apiConfig.apiUrl}/refresh_token`, {
        refresh_token: token,
    })

    document.cookie = `access_token=${response.data.access_token}; max-age=${response.data.expires_in}; path=/;`
    document.cookie = `refresh_token=${response.data.refresh_token}; max-age=5184000; path=/;`
    document.cookie = `expires_in=${response.data.expires_in}; max-age=${response.data.expires_in}; path=/;`
    setTimeout(() => {
        isUpdating = false
    }, 200)
}

function create() {
    return axios.create({
        baseURL: $apiConfig.apiUrl,
    })
}

function withAuthorization(instance) {
    instance.interceptors.request.use(async (config) => {
        const localConfig = { ...config }
        if (!isLogged() && !hasRefreshToken() && !canSendRequest(config.url)) {
            const source = axios.CancelToken.source()
            localConfig.cancelToken = source.token
            source.cancel()
            logout()
        }

        if (!isLogged() && hasRefreshToken()) {
            await updateToken()
        }

        if (isLogged()) {
            localConfig.headers.Authorization = `Bearer ${window.cookieBridge.getCookie('access_token')}`
        }

        return localConfig
    })

    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response) {
                const { status } = error.response

                if (status === 422) {
                    Notification({
                        title: 'Error occurred',
                        message: error.response.data.fields[0].message || 'Something went wrong',
                        duration: 5000,
                    })
                } else if (status === 409) {
                    Notification({
                        title: 'Error occurred',
                        message: error.response.data.message || 'Something went wrong',
                        duration: 5000,
                    })
                } else if (status === 500 || status === 400) {
                    Notification({
                        title: 'Server technical works',
                        message: 'We\'re sorry. We have technical works',
                        duration: 5000,
                    })
                } else if (status === 403) {
                    Notification({
                        title: 'Error 403',
                        message: error.response.data.message,
                        duration: 5000,
                    })
                } else if (status === 401) {
                    logout()
                }
            }

            return error.response
        },
    )
}

const localAxios = create()
withAuthorization(localAxios)

export {
    localAxios,
    logout,
}
